export function getTypes(user){
    if (
        !user
        || !user.profils
        || user.profils.length === 0
    ) return 'ALL'; //TODO : NONE

    if (user.profils.includes('Admin')) return 'ALL';
    if (user.profils.includes('SaisieLog')) return 'ALL';

    let productionTypes = []
    if (user.profils.includes('SaisieALU')) productionTypes.push('ALU');
    if (user.profils.includes('SaisieNEG')) productionTypes.push('NEG');
    if (user.profils.includes('SaisiePVC')) productionTypes.push('PVC');
    if (user.profils.includes('SaisieVR')) productionTypes.push('VR');

    return productionTypes;
}

export function checkRole(user, zone, role) {
    if (
        !user
        || !user.profils
        || user.profils.length === 0
    ) return true; // TODO: false

    if (user.profils.includes('Admin')) return true;

    switch(zone) {
        case 'creation':
            return user.profils.includes('CreationCommande');
        case 'date':
            return user.profils.includes('CreationCommande')
                    || user.profils.includes('SaisieLog')
        case 'statut':
            return user.profils.includes('CreationCommande')
                || user.profils.includes('SaisieLog')
        case 'produit':
            return user.profils.includes('SaisieLog');
        case 'envoye':
            return user.profils.includes('SaisieLog');
        case 'detail':
            return true;
        case 'modification':
            return user.profils.includes('CreationCommande');
        case 'suppressionCommande':
            return user.profils.includes('CreationCommande');
        case 'suppressionLigne':
            if(user.profils.includes('SaisieLog')) return true;
            return user.profils.includes('Saisie' + role);
        case 'commentaire':
            if(user.profils.includes('SaisieLog')) return true;
            return user.profils.includes('Saisie' + role);
        case 'qte':
            return user.profils.includes('Saisie' + role);
        case 'raf':
            return user.profils.includes('Saisie' + role);
        case 'zone':
            return user.profils.includes('Saisie' + role);
        case 'valide':
            return user.profils.includes('Saisie' + role);
        case 'finalise':
            if(zone === 'LOG' && user.profils.includes('SaisieLog')) return true;
            return user.profils.includes('Saisie' + role);
        default:
            return false;
    }

}

